<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>换货详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>换货单号</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.no}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="goodsRecvVoucher.orderFlag">
                <div class="form-label">
                    <label>订单号</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ goodsRecvVoucher.orderNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货单号</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ goodsRecvVoucher.shipNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货机构</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.senderComName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货人</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.senderContactName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发货人联系方式</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.senderContactTel}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>换货时间</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.returnTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>换货地址</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.buyerRecvAddr}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>换货原因</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-select placeholder="请选择" v-model="goodsRecvVoucher.returnCause" :clearable=true>
                        <el-option v-for="item in goodsExchgCauseList" :key="item.name" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>换货原因说明</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.returnDesc}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>换货受理状态</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="goodsRecvVoucher.returnAcceptState == 0">未处理</span>
                    <span v-if="goodsRecvVoucher.returnAcceptState == 1">已接受</span>
                    <span v-if="goodsRecvVoucher.returnAcceptState == -1">已拒绝</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>换货受理意见</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.returnHandleDesc}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>换货受理人</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.returnHandlerName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>物流单号</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.returnLogisExpNo}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>物流公司名称</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{goodsRecvVoucher.returnLogisComName}}</span>
                </div>
            </div>
        </div>
        <div class="table-layout">
            <el-form>
                <el-table ref="multipleTable" :data="goodsRecvVoucher.goodsRecvVoucherItemList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column align="center" label="资产信息" v-if="showAssetInfo">
                        <el-table-column align="left" width="130" prop="devcName" label="名称" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="devcCatName" label="分类" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="devcBrandName" label="品牌" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="130" prop="devcModel" label="型号" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="130" prop="devcFixedSpec" label="规格" show-overflow-tooltip></el-table-column>
                    </el-table-column>
                    <el-table-column align="center" label="商品信息" v-if="showAssetInfo">
                        <el-table-column align="left" width="130" prop="title" label="名称" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="100" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="130" prop="model" label="型号" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="130" prop="fixedSpec" label="规格" show-overflow-tooltip></el-table-column>
                    </el-table-column>
                    <el-table-column align="left" prop="title" label="名称" width="150" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                    <el-table-column align="left" width="120" prop="catName" label="分类" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                    <el-table-column align="left" width="100" prop="brandName" label="品牌" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                    <el-table-column align="left" width="130" prop="model" label="型号" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                    <el-table-column align="left" width="130" prop="fixedSpec" label="规格" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>

                    <el-table-column align="center" prop="asmblAccFlag" label="组装件" width="60" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.asmblAccFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="setupFlag" label="需要安装" width="80" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.setupFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="asmblFlag" label="含组装商品" width="80" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.asmblFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="right" prop="quantity" label="换货数量" width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="desc" label="描述" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="操作" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <a class="swb-btn-link" @click="exchgGoods(scope.row)" v-if="scope.row.assetType == 0">换货明细</a>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
        </div>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary mr10" @click="prevContract">返回</button>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { showGoodsRecvReturnItemListViewDialog } from './dialog'
    import { getMerchantBizParam } from '../asset/assetMain'

    import goodsDelivApi from '../../api/goodsDeliv'
    import goodsOperApi from '../../api/goodsOper'

    export default {
        name: 'swb-goods-exchg-voucher-info',
        path: '/goods/exchg/voucher/info',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '换货单详情',
        data: function () {
            return {
                goodsRecvVoucher: {},
                goodsExchgCauseList: [],
                showAssetInfo: false
            }
        },
        created: function () {
            //
            let id = this.$route.query.id || null;
            //
            let self = this;
            getMerchantBizParam("display.asset.related.info.in.trading", function (result) {
                self.showAssetInfo = Utils.isTrue(result);
            });
            this.getGoodsRecvVoucher(id);
            this.getGoodsExchgCauseList();
        },
        methods: {
            prevContract: function () {
                let self = this;
                self.$router.back(-1);
            },
            // 换货详情
            getGoodsRecvVoucher: function (id) {
                let self = this;
                let postData = {};
                postData.id = id;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsRecvVoucherInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        self.goodsRecvVoucher = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 换货原因列表
            getGoodsExchgCauseList: function () {
                let self = this;
                let postData = {};
                goodsOperApi.getGoodsExchgCauseList(postData, function (result) {
                    if(result.type == "info") {
                        self.goodsExchgCauseList = result.data;
                        let endData = {id: -1, name: '其他'};
                        self.goodsExchgCauseList.push(endData);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 换货明细
            exchgGoods: function (row) {
                let params = {
                    recvVoucherItemId: row.id,
                    recvVoucherId: row.voucherId,
                    optionFlag: 'exchg'
                };
                showGoodsRecvReturnItemListViewDialog(params);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsExchgVoucherInfo.vue